import Loadable from 'components/core/Loadable';
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

// Auth
const Page404Page = Loadable(lazy(() => import('pages/404Page/index')));


const Page404: RouteObject = {
  path: 'not-found',
  element: <Page404Page />,
};

export default Page404;
